import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Cookie from 'js-cookie'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    children: [
      {
        path: '',
        name: 'Index',
        component: () => import('../views/index.vue'),
      }
    ]
  },
  {
    path: '/haokang',
    name: 'articleEdit',
    component: () => import('../views/admin/articleEdit.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


// 路由守卫
router.beforeEach((to, from, next) => {

  // 刷新页面会丢失登录状态，所以刷新后要从Cookie里获取token再次存放在vuex
  if (Cookie.get('token'))
    store.commit('setToken', Cookie.get('token'))

  //  判断有无token，有则设置当前状态为登录状态
  if (Cookie.get('token')) {
    store.commit('changIsSignIn', 1)
  }
  else {
    store.commit('changIsSignIn', 0)
  }
  next()
})

export default router
